import NumUnitsModel from '../models/num_units_model';

export default Backbone.View.extend({
  template: Mustache.template('new_design/common/num_units'),
  bindings: {
    '.js-num-units-select': {
      observe: 'num_units',
      onSet(value) {
        return parseInt(value, 10);
      },
    },
    '.js-num-units-description': {
      observe: 'num_units',
      onGet: 'getDescription',
    },
  },
  initialize(opts) {
    this.model = new NumUnitsModel();
    this.descriptions = opts.desc;
    this.context = {
      label: opts.label,
      desc: this.getDescription(),
    };

    Backbone.$ = window.$; // Remove once we are off the old version of Backbone
  },
  render() {
    const ctx = _.extend(this.context, this.model.attributes);
    this.$el.html(this.template.render(ctx));
    this.stickit();
    setTimeout(() => {
      $('.js-num-units-select').val(this.model.get('num_units'));
    }, 0);
    return this;
  },
  getDescription(numUnits) {
    if (numUnits === 1) return this.descriptions.singular;
    return this.descriptions.plural;
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/service_num_units_view.js